import React from "react";
import PropTypes from "prop-types";
import PostPurchaseProductBlock from "../../../../../layouts/checkout-extension/post-purchase/PostPurchaseProductBlock";

/** Post-purchase pop page — image left, product info right (grid layout). */
export default function ExtensionTwoColumnLayout({
  popupData,
  section,
  activeStep,
  parentIndex,
  footerContent,
}) {
  return (
    <PostPurchaseProductBlock
      layout="grid"
      popupData={popupData}
      section={section}
      activeStep={activeStep}
      parentIndex={parentIndex}
      footerContent={footerContent}
    />
  );
}

ExtensionTwoColumnLayout.propTypes = {
  popupData: PropTypes.object,
  section: PropTypes.object,
  activeStep: PropTypes.number,
  parentIndex: PropTypes.number,
  footerContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};
